import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    parentContainer: InjectableCss;
    logoContainer: InjectableCss;
    mainNavigationWrapper: InjectableCss;
    headerActionsContainer: InjectableCss;
    linkListContainer: InjectableCss;
    secondaryNavigation: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            flex: 0 0 100%;
            margin: 0 auto;
            flex-wrap: wrap;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        max-width: none;
                        flex-wrap: wrap;
                        padding: 0;
                    `,
                    css`
                        max-width: none;
                        flex-wrap: wrap;
                        padding: 0;
                    `,
                    css`
                        max-width: none;
                        flex-wrap: wrap;
                        padding: 0;
                    `,
                    css`
                        max-width: ${maxWidths[3]}px;
                    `,
                    css`
                        max-width: ${maxWidths[4]}px;
                    `,
                ]);
            }}
            padding: 7px 10px 7px 10px;
            margin: 0 auto;
            align-items: center;
        `,
    },
    parentContainer: {
        css: css`
            background-color: ${getColor("secondary.main")};
            display: flex;
            flex-wrap: wrap;
        `,
    },
    mainNavigationWrapper: {
        css: css`
            display: flex;
            align-items: center;
            flex: 1 0 auto;
            padding: 0;
        `,
    },
    headerActionsContainer: {
        css: css`
            flex: 1 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                    display: none;
                `,
                    css`
                    display: none;
                `,
                    css`
                    display: none;
                `,
                    css`
                `,
                    css`
                `,
                ]);
            }}
        `,
    },
    logoContainer: {
        css: css`
        flex: 0 0 auto;
        ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                    padding: 25px 15px;
                    text-align: center;
                    flex: 0 0 100%;
                    display: flex;
                    justify-content: center;
                `,
                    css`
                    padding: 25px 15px;
                    justify-content: center;
                    flex: 0 0 100%;
                    display: flex;
                `,
                    css`
                    padding: 25px 15px;
                    justify-content: center;
                    flex: 0 0 100%;
                    display: flex;
                `,
                    css`
                    flex: 0 0 100%;
                    display: flex;
                `,
                    css`
                    padding-right: 25px;
                `,
                ]);
            }}`,
    },
    linkListContainer: {
        css: css`
        flex: 0 0 230px;
        ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                    display: none;
                `,
                    css`
                    display: none;
                `,
                    css`
                    display: none;
                `,
                    css`
                `,
                    css`
                `,
                ]);
            }}`,
    },
    secondaryNavigation: {
        css: css`
        margin: auto;
        padding: 7px 15px 7px 15px;
        ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                    display: none;
                `,
                    css`
                    display: none;
                `,
                    css`
                    display: none;
                `,
                    css`
                    max-width: ${maxWidths[3]}px;
                `,
                    css`
                    max-width: ${maxWidths[4]}px;
                `,
                ]);
            }}`,
    }
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <>
        <StyledWrapper style={{ backgroundColor: "#395C3A" }}>
            <StyledWrapper {...logoLinksSearchStyles.secondaryNavigation}>
                <Zone contentId={id} zoneName="SecondaryNavigation" />
            </StyledWrapper>
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.parentContainer} className="logoLinkSearchParent">
            <StyledWrapper {...logoLinksSearchStyles.container} className="logoLinksSearchLogoActionsContainer">
                <StyledWrapper {...logoLinksSearchStyles.logoContainer} className="logoLinksSearchLogo">
                    <Zone contentId={id} zoneName="Logo" />
                </StyledWrapper>
                <StyledWrapper {...logoLinksSearchStyles.headerActionsContainer} className="logoLinkSearchHeaderActions">
                    <Zone contentId={id} zoneName="HeaderActions" />
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.container} className="logoLinkSearchWrapper">
                <StyledWrapper {...logoLinksSearchStyles.mainNavigationWrapper} className="logoLinkSearchMainNavWrapper">
                    <Zone contentId={id} zoneName="MainNavigation" />
                </StyledWrapper>
                <StyledWrapper {...logoLinksSearchStyles.linkListContainer}>
                    <Zone contentId={id} zoneName="LinkList" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    </>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Header",
        icon: "Filter",
        fieldDefinitions: [],
    },
};

export default logoLinksSearch;
